import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import {
  MobileDateRangePicker,
  MobileDateRangePickerProps,
} from "@mui/x-date-pickers-pro/MobileDateRangePicker";
import { FormControl, FormLabel } from "@mui/material";
import { Dayjs } from "dayjs";

function DateRangeInput({
  label,
  labelStart,
  labelEnd,
  ...rest
}: MobileDateRangePickerProps<Dayjs> & {
  label?: string;
  labelStart?: string;
  labelEnd?: string;
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormControl sx={{ gap: "var(--gap-small)" }}>
        <FormLabel>{label}</FormLabel>
        <MobileDateRangePicker
          localeText={{
            start: labelStart ?? "Început",
            end: labelEnd ?? "Final",
          }}
          format="DD/MM/YYYY"
          {...rest}
        />
      </FormControl>
    </LocalizationProvider>
  );
}

export default DateRangeInput;
